import { SectionLabel, CtaButton, Reveal } from "./shared";

const CARDS = [
  { icon: "🏡", text: "Buyers planning a home purchase with VA-backed financing in the next 3–12 months" },
  { icon: "🔁", text: "Households with remaining entitlement who have used a VA-backed loan before" },
  { icon: "🏘️", text: "Owners of an existing VA-financed home considering a move-up purchase" },
  { icon: "💵", text: "Buyers unsure how cash-to-close and buying power actually work together" },
  { icon: "❓", text: "Anyone who got a \u201Cno\u201D and never learned whether deal structure was the reason" },
];

export default function Audience() {
  return (
    <section id="learn" className="py-24 lg:py-36 px-6 lg:px-10" data-testid="audience-section">
      <div className="max-w-6xl mx-auto">
        <Reveal>
          <SectionLabel n="003" text="WHO THIS IS FOR" />
          <h2 className="font-black uppercase text-3xl md:text-4xl tracking-tight mb-12">
            THIS MASTERCLASS IS DESIGNED FOR:
          </h2>
        </Reveal>
        <div className="grid grid-cols-2 lg:grid-cols-3 gap-4">
          {CARDS.map((c, i) => (
            <Reveal key={i} delay={i * 0.07} className={i === 4 ? "col-span-2 lg:col-span-1" : ""}>
              <div
                className="h-full p-6 border border-white/10 bg-[#00224F]/40 hover:border-[#0162CA] hover:bg-[#0162CA]/[0.08] hover:scale-[1.02] transition-[border-color,background-color,transform] duration-300"
                data-testid={`audience-card-${i + 1}`}
              >
                <div className="text-2xl mb-4">{c.icon}</div>
                <p className="text-white/75 text-sm leading-relaxed">{c.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.2}>
          <p className="mt-6 text-[11px] text-white/35 max-w-2xl">
            Educational content only. Eligibility for VA-backed financing is determined by the U.S. Department of
            Veterans Affairs and the lender, not by attending this class.
          </p>
          <div className="mt-8">
            <CtaButton testId="audience-cta" />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
